import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import { Input, Modal, Select } from 'antd';
import { Btn, RequiredSign } from '../../../components/Widgets';
import './DeptAddEdit.less';

const Option = Select.Option;

class DeptAddEdit extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      deptAddEditStatus,
      deptAddEditParent,
      deptAddEditValue,
      intl,
    } = this.props;
    let title = '新增';
    if (deptAddEditStatus == 2) {
      title = '编辑';
    }
    return (
      <Modal
        visible={deptAddEditStatus > 0}
        title={
          deptAddEditParent.level != 0
            ? title + '子公司、子部门'
            : title + '子部门'
        }
        onCancel={this.close}
        wrapClassName="modal-close-header dept-addEdit-modal-header"
        footer={
          <div className="dept-addEdit-footer">
            <Btn onClick={this.close}>取消</Btn>
            <Btn primary onClick={this.save}>
              确定
            </Btn>
          </div>
        }
      >
        <div className="dept-addEdit-content">
          <div className="dept-addEdit-row">
            <span className="prefix-title">
              {deptAddEditParent.level == 0 ? '上级部门' : '上级公司'} :{' '}
            </span>
            <div>{deptAddEditParent.name}</div>
          </div>
          <div className="dept-addEdit-row" style={{ display: 'none' }}>
            <span className="prefix-title">
              <RequiredSign />
              类型 :{' '}
            </span>
            <Select
              defaultValue="0"
              value={deptAddEditValue.level}
              onChange={this.onSelectChange.bind(this, 'level')}
              disabled={deptAddEditStatus == 2}
            >
              <Option value="0">部门</Option>
              <Option value="1" disabled={deptAddEditParent.level == 0}>
                公司
              </Option>
            </Select>
          </div>
          <div className="dept-addEdit-row">
            <span className="prefix-title">
              <RequiredSign />
              名称 :{' '}
            </span>
            <Input
              value={deptAddEditValue.name}
              maxLength={'15'}
              onChange={this.onChange.bind(this, 'name')}
            />
          </div>
        </div>
      </Modal>
    );
  }

  onSelectChange = (property, e) => {
    const { updateAddEdit } = this.props;
    updateAddEdit && updateAddEdit('dept', property, e);
  };
  onChange = (property, e) => {
    const { updateAddEdit } = this.props;
    updateAddEdit && updateAddEdit('dept', property, e.target.value);
  };
  close = () => {
    const { onCancel } = this.props;
    onCancel && onCancel();
  };
  save = () => {
    const { save, deptAddEditValue } = this.props;
    if (!deptAddEditValue.name) {
      Modal.error({ content: '请填写名称！' });
      return;
    }
    save && save('dept');
  };
}

export default connect()(injectIntl(DeptAddEdit));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/DeptUserManage/DeptAddEdit.js